import React from 'react';
import Section from '../../Section';
import OrdersTable from './OrdersTable';
import {filterOrders, ORDER_SEGMENTS} from './orderFilters';
import useSellerOrders from './useSellerOrders';
import './Orders.css';

function OrdersAttentionWidget() {
  const {orders, loading, error} = useSellerOrders();
  const attentionOrders = filterOrders(orders, ORDER_SEGMENTS.ATTENTION);

  if (loading || error || attentionOrders.length === 0) return null;

  return (
    <Section
      id="orders-needing-attention"
      title="Orders Needing Attention"
      preview="You have orders that need to be fulfilled."
    >
      <p>You have {attentionOrders.length} order{attentionOrders.length === 1 ? '' : 's'} that
        need{attentionOrders.length === 1 ? 's' : ''} attention.</p>
      <OrdersTable orders={attentionOrders} variant={ORDER_SEGMENTS.ATTENTION} />
      <p style={{marginTop: '1rem', marginBottom: '1rem'}}>
        <a href="/account/orders/labels" className="help-link">
          Print Packing, Address, and Return Labels for these orders{' '}
          <i className="fa-solid fa-print" aria-hidden="true"></i>
        </a>
      </p>
      <p>
        <a href="/help/processing-orders" className="help-link" target="_blank">
          Learn how to process orders{' '}
          <i className="fa-solid fa-question-circle" aria-hidden="true"></i>
        </a>
      </p>
    </Section>
  );
}

export default OrdersAttentionWidget;
